import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import AccentTextView from './views/AccentTextView';
import DarkAccentTextView from './views/DarkAccentTextView';
import ButtonView from './views/ButtonView';
import WhiteTextView from './views/WhiteTextView';
import CertificatePopup from './views/CertificatePopup';

import fetchCertificateTemplate from './relay/fetchCertificateTemplate';

class ViewCertificate extends Component {
  static contextTypes = {
    getCurrentUserInfo: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      showCertificate: false,
      fetchingTemplate: true,
      certificate: ''
    };
  }

  showSnackbar = (label, status = 'error') => {
    SnackBarHelper.showSnackbar({
      label,
      duration: 7,
      status
    });
  };

  handleViewCertificate = async event => {
    event.stopPropagation();
    event.preventDefault();
    try {
      if (!this.props.certificateData || !this.props.certificateData.certificateTemplateId) {
        return;
      }
      const { certificateTemplateId } = this.props.certificateData;
      this.setState({ showCertificate: true });
      const certificate = await fetchCertificateTemplate(certificateTemplateId);
      this.setState({ fetchingTemplate: false, certificate });
    } catch (e) {
      console.log('Error while fetching certificateTemplate', e);
      this.showSnackbar('Error while fetching certificate.');
    }
  };

  handleCloseCertificiate = event => {
    this.setState({ showCertificate: false });
    event.stopPropagation();
    event.preventDefault();
  };

  render() {
    const { type, certificateData } = this.props;
    const { showCertificate, fetchingTemplate, certificate } = this.state;
    const components = {
      AccentTextView,
      ButtonView,
      WhiteTextView,
      DarkAccentTextView
    };
    const ViewComponent = components[type];
    return (
      <React.Fragment>
        <ViewComponent handleClick={this.handleViewCertificate} />
        <CertificatePopup
          showCertificate={showCertificate}
          fetchingTemplate={fetchingTemplate}
          certificate={certificate}
          handleCloseCertificiate={this.handleCloseCertificiate}
          certificateData={certificateData}
        />
      </React.Fragment>
    );
  }
}

ViewCertificate.propTypes = {
  type: PropTypes.oneOf(['AccentTextView', 'ButtonView', 'WhiteTextView', 'DarkAccentTextView'])
    .isRequired,
  certificateData: PropTypes.shape({
    issuedDate: PropTypes.string.isRequired,
    certificateSettings: PropTypes.shape({
      includeApprover: PropTypes.bool.isRequired,
      includeCompletionDate: PropTypes.bool.isRequired,
      includeScore: PropTypes.bool.isRequired,
      dontPublishOnLinkedIn: PropTypes.bool
    }).isRequired,
    issueId: PropTypes.string.isRequired,
    certificateData: PropTypes.shape({
      score: PropTypes.number,
      completionDate: PropTypes.string,
      approverName: PropTypes.string
    }).isRequired,
    certificateTemplateId: PropTypes.string.isRequired
  }).isRequired
};

export default ViewCertificate;
